// 这里只固定状态文案，不定义或兜底生成标签名称。
export const MEMBER_TAG_STATES = {
  CURRENT: { label: '当前记录', color: 'blue' },
  NEEDS_CONFIRMATION: { label: '待确认', color: 'orange' },
  PLANNED: { label: '计划中', color: 'cyan' },
  RESOLVED: { label: '已解除', color: 'green' },
  HISTORY: { label: '历史', color: 'default' },
};

export function tagState(state) {
  return Object.prototype.hasOwnProperty.call(MEMBER_TAG_STATES, state)
    ? MEMBER_TAG_STATES[state]
    : MEMBER_TAG_STATES.NEEDS_CONFIRMATION;
}

export function readTagEvidence(
  response,
  memberId,
  observationId,
  expectedKind,
) {
  const data = response?.data;
  if (
    !['00000', '0'].includes(String(response?.code)) ||
    String(data?.memberId) !== String(memberId) ||
    data?.observationId !== observationId ||
    !['AVAILABLE', 'UNAVAILABLE', 'UNSUPPORTED'].includes(data?.status) ||
    (data?.status === 'AVAILABLE' &&
      expectedKind &&
      (data.evidenceKind || 'QUESTIONNAIRE_ANSWER') !== expectedKind) ||
    (data?.evidenceKind != null &&
      !['QUESTIONNAIRE_ANSWER', 'COURSE_SUMMARY', 'CHAT_MESSAGE'].includes(
        data.evidenceKind,
      )) ||
    !Array.isArray(data?.items) ||
    data.items.length > (data.evidenceKind === 'CHAT_MESSAGE' ? 20 : 14) ||
    (data.status === 'AVAILABLE') !== data.items.length > 0 ||
    data.items.some(
      (item) =>
        !item ||
        typeof item.ref !== 'string' ||
        !item.ref ||
        typeof item.question !== 'string' ||
        !item.question ||
        item.question.length > 100 ||
        typeof item.answer !== 'string' ||
        !item.answer ||
        item.answer.length >
          (data.evidenceKind === 'COURSE_SUMMARY' ? 800 : 600),
    )
  ) {
    throw new Error('标签证据响应无效');
  }
  return data;
}

export function readTagPage(response, memberId, beforeCursor) {
  const page = response?.data;
  if (
    !['00000', '0'].includes(String(response?.code)) ||
    String(page?.memberId) !== String(memberId) ||
    !Array.isArray(page?.items) ||
    page.items.length > 20 ||
    typeof page.hasMore !== 'boolean'
  ) {
    throw new Error('会员标签查询失败，请重试');
  }
  if (page.hasMore) {
    const next = page.nextCursor;
    if (
      typeof next !== 'string' ||
      !/^[1-9][0-9]{0,18}$/.test(next) ||
      (beforeCursor &&
        (next.length > beforeCursor.length ||
          (next.length === beforeCursor.length && next >= beforeCursor)))
    ) {
      throw new Error('标签分页异常，请刷新');
    }
  }
  if (
    page.items.some(
      (item) =>
        !item ||
        typeof item.observationId !== 'string' ||
        !item.observationId ||
        typeof item.name !== 'string' ||
        !item.name.trim() ||
        item.name.length > 24,
    )
  ) {
    throw new Error('标签数据异常，请刷新');
  }
  return page;
}
